module.exports = __webpack_public_path__ + "img/3.ec7cab0d.png";